module.exports = __webpack_public_path__ + "img/header1.34428656.png";